import { render, staticRenderFns } from "./ArtistDropdown.vue?vue&type=template&id=26941850"
import script from "./ArtistDropdown.vue?vue&type=script&lang=js"
export * from "./ArtistDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports